// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M2GSZHJlPgJAtHrEUTCo{width:100%;height:100%;position:relative}.bnXiESGK0Us0OwdPNwHX{border:1px solid var(--action-outlined-tertiary-border);background:var(--background-primary-inverted-primary);border-radius:4px;padding:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `M2GSZHJlPgJAtHrEUTCo`,
	"icon": `bnXiESGK0Us0OwdPNwHX`
};
export default ___CSS_LOADER_EXPORT___;
